import { render, staticRenderFns } from "./steelPanelFile.vue?vue&type=template&id=8fd66714&scoped=true"
import script from "./steelPanelFile.vue?vue&type=script&lang=js"
export * from "./steelPanelFile.vue?vue&type=script&lang=js"
import style0 from "./steelPanelFile.vue?vue&type=style&index=0&id=8fd66714&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fd66714",
  null
  
)

export default component.exports